import PinchZoom from "pinch-zoom-js";
import app from "../_app";

const gallery = document.querySelector('.js-product-gallery');

if (gallery) {

    const $thumb = [...gallery.querySelectorAll('.js-gallery-thumb')],
        $images = gallery.querySelector('.js-gallery-images'),
        $triggers = [...document.querySelectorAll('.js-product-gallery-trigger')],
        galleryImages = [...document.querySelectorAll('.js-gallery-image')],
        $controls = document.querySelector('.gallery__controls'),
        $sliderTrack = document.querySelector('.js-image-slider').querySelector('.js-slider-track');

    $triggers.map(trigger => {
        trigger.addEventListener('click', () => {

            let $currentTumb = trigger.dataset.count;
            const height = window.innerHeight;

            if (typeof $currentTumb === 'undefined') {
                $currentTumb = $sliderTrack.scrollLeft / $sliderTrack.querySelector('.js-product-gallery-trigger').offsetWidth;
            }

            $controls.dataset.current = $currentTumb;

            gallery.classList.add('active');
            app.lockBody();

            if(window.innerWidth >= 767) {

                var imagesHeight = height * $thumb.length + 'px';

                $images.style.height = imagesHeight;
                $images.querySelector('.row').style.height = imagesHeight;

                if($currentTumb >= 0) {
                    var targetImage = galleryImages[$currentTumb];
                    var scrollTopValue = targetImage.offsetTop;

                    setTimeout(() => {
                        gallery.scrollTop = scrollTopValue;
                    }, 250);
                }
            }

            if(window.innerWidth < 768) {

                if(!galleryImages[0].parentElement.classList.contains('pinch-zoom-container')){

                    galleryImages.map(galleryImage => {

                        const options = {
                            tapZoomFactor: 2,
                            zoomOutFactor: 1.3,
                            animationDuration: 300,
                            maxZoom: 4,
                            minZoom: 0.5,
                            draggableUnzoomed: false,
                            lockDragAxis: false,
                            setOffsetsOnce: false,
                            use2d: true,
                            verticalPadding: 0,
                            horizontalPadding: 0
                        }

                        let pz = new PinchZoom(galleryImage, options);
                    });
                }

                if($currentTumb >= 0) {
                    var targetImage = galleryImages[$currentTumb];

                    setTimeout(() => {
                        document.querySelector('.js-gallery-track').scrollLeft = targetImage.parentElement.offsetLeft;
                    }, 100);

                }
            }

        });
    });

    $thumb.map(thumb => {
        thumb.addEventListener('click', () => {
            if(window.innerWidth >= 767) {

                const height = window.innerHeight;
                const offset = (height * thumb.dataset.count);;
                gallery.scrollTop = offset;

            }else{
                const $currentTumb = thumb.dataset.count;
                const targetImage = galleryImages[$currentTumb];

                setTimeout(() => {
                    document.querySelector('.js-gallery-track').scrollLeft = targetImage.parentElement.offsetLeft;
                }, 100);

            }
        });
    });


    const close = document.querySelector('.js-gallery-close');

    gallery.addEventListener('click', () => {
        gallery.classList.remove('active');
        app.unlockBody();
    });
    close.addEventListener('click', () => {
        gallery.classList.remove('active');
        app.unlockBody();
    });

    $thumb.map(thumb => {
        thumb.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });

    document.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) {
            gallery.classList.remove('active');
            app.unlockBody();
        }
    });

    const scrollHandler = (index) => {

        const track = document.querySelector('.js-gallery-track');
        const elements = track.children;
        let currentIndex = index ? index : 0;

        if(window.innerWidth < 767) {

            const scrollLeft = track.scrollLeft;

            for(let i = 0; i < elements.length; i++) {
                if((elements[i].offsetLeft + (elements[i].clientHeight * .5)) >= scrollLeft) {
                    currentIndex = i;
                    break;
                }
            }

        } else {
            const scrollTop = gallery.scrollTop;
            for(let i = 0; i < elements.length; i++) {

                if((elements[i].offsetTop + (elements[i].clientHeight * .85)) >= scrollTop) {
                    currentIndex = i;
                    break;
                }
            }
        }

        for(let i = 0; i < (elements.length); i++) {
            $thumb[i].classList.remove('active');
        }

        $thumb[currentIndex].classList.add('active');
    };

    gallery.addEventListener('scroll', () => {
        scrollHandler();
    });
    gallery.querySelector('.js-gallery-images .row').addEventListener('scroll', () => {
        scrollHandler();
    });

    const prev = gallery.querySelector('.js-controls-prev'),
          next = gallery.querySelector('.js-controls-next');

    prev.addEventListener('click', (e) => {
        e.stopPropagation();

        let prevImage = parseInt($controls.dataset.current) <= 0 ? parseInt($controls.dataset.total) : parseInt($controls.dataset.current) - 1;
        let targetImage = galleryImages[prevImage];
        $controls.dataset.current = prevImage;

        setTimeout(() => {
            document.querySelector('.js-gallery-track').scrollLeft = targetImage.parentElement.offsetLeft;
        }, 100);
    });
    next.addEventListener('click', (e) => {
        e.stopPropagation();

        let nextImage = (parseInt($controls.dataset.current) < parseInt($controls.dataset.total)) ? parseInt($controls.dataset.current) + 1 : 0;
        let targetImage = galleryImages[nextImage];
        $controls.dataset.current = nextImage;

        setTimeout(() => {
            document.querySelector('.js-gallery-track').scrollLeft = targetImage.parentElement.offsetLeft;
        }, 100);
    });
}
